import React, { useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  TextField,
  FormControl,
  InputLabel,
  Select,
  FormHelperText,
} from '@material-ui/core';
import { useHistory } from 'react-router-dom';

import { USA_STATES } from 'common/constants';
import { COUNTIES } from 'util/APIUtils';
import { scrollToEl } from 'util/helpers';
import {
  updateBrandAddress,
} from 'modules/brandRegistration';
import { selectBrandAddress } from 'selectors/brandRegistration';
import FormValidator from 'components/formValidator';
import { useFormStyles } from '../styles';
import { ADDRESS_DESCRIPTOR } from '../constants';
import StepActions from './StepActions';

const BrandAddress = () => {
  const dispatch = useDispatch();
  const address = useSelector(selectBrandAddress);
  const formRef = useRef(null);
  const formClasses = useFormStyles();
  const history = useHistory();

  const buildInput = ({ id, value, label, setFormValue, error }) => {
    return (
      <TextField
        id={id}
        value={value}
        label={label}
        variant="outlined"
        size="small"
        onChange={(ev) => {
          setFormValue(id, ev.target.value);
        }}
        error={!!error}
        helperText={error}
      />
    );
  };

  const buildSelect = ({ options, id, label, value, setFormValue, error, keyValue = false }) => {
    return (
      <FormControl
        variant="outlined"
        size="small"
        error={!!error}
      >
        <InputLabel htmlFor={id}>{label}</InputLabel>
        <Select
          native
          value={value}
          id={id}
          label={label}
          onChange={(ev) => {
            setFormValue(id, ev.target.value);
          }}
        >
          <option aria-label="None" value="" />
          {options instanceof Array ?
            (
              options.map((county) =>
                <option key={county} value={county}>{county}</option>
              )
            ) : (
              Object.entries(options).map(([key, type]) =>
                <option key={key} value={keyValue ? key : type}>{type}</option>
              )
            )
          }
        </Select>
        {!!error && <FormHelperText>{error}</FormHelperText>}
      </FormControl>
    );
  }

  const handleFormSubmit = (ev, { errors, formData }) => {
    ev.preventDefault();

    if (!errors) {
      dispatch(updateBrandAddress(formData));

      // history.push('/brands/new/checkout');
      history.push('/cart');
    } else {
      const firstError = Object.keys(errors)[0];
      const field = document.querySelector(`#${firstError}`);

      if (field) {
        scrollToEl(field);
        field.focus();
      }
    }
  };

  const handleNext = () => {
    formRef.current.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
  };

  const handleBack = () => {
    history.push('/brands/new/owners');
  };

  return (
    <React.Fragment>
      <StepActions handleCheckout={handleNext} handleBack={handleBack} />
      <center>
        <h2>Brand Address</h2>
      </center>
      <FormValidator
        initialData={address}
        descriptor={ADDRESS_DESCRIPTOR}
        onSubmit={handleFormSubmit}
      >
        {({ formData, setFormValue, handleSubmit, errors = {} }) => {
          return (
            <form className={formClasses.root} onSubmit={handleSubmit} ref={formRef}>
              {buildInput({ id: 'lineOne', label: 'Line One', value: formData.lineOne, setFormValue, error: errors.lineOne })}
              {buildInput({ id: 'lineTwo', label: 'Line Two', value: formData.lineTwo, setFormValue, error: errors.lineTwo })}
              <div className="row row-2">
                {buildInput({ id: 'city', label: 'City', value: formData.city, setFormValue, error: errors.city })}
                {buildSelect({ id: 'state', label: 'State', value: formData.state, options: USA_STATES, setFormValue, error: errors.state, keyValue: true })}
              </div>
              <div className="row row-2">
                {buildInput({ id: 'zipcode', label: 'Zip Code', value: formData.zipcode, setFormValue, error: errors.zipcode })}
                {buildSelect({ id: 'county', label: 'County', value: formData.county, options: COUNTIES, setFormValue, error: errors.county })}
              </div>
            </form>
          );
        }}
      </FormValidator>
      <StepActions handleCheckout={handleNext} handleBack={handleBack} />
    </React.Fragment>
  );
};

export default BrandAddress;
